var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22917 1.0835C3.68875 1.0835 1.625 3.14725 1.625 5.68766C1.625 8.22808 3.68875 10.2918 6.22917 10.2918H6.5V11.9168C9.1325 10.6493 10.8333 8.12516 10.8333 5.68766C10.8333 3.14725 8.76958 1.0835 6.22917 1.0835ZM6.77083 8.93766H5.6875V7.85433H6.77083V8.93766ZM6.77083 7.04183H5.6875C5.6875 5.28141 7.3125 5.41683 7.3125 4.3335C7.3125 3.73766 6.825 3.25016 6.22917 3.25016C5.63333 3.25016 5.14583 3.73766 5.14583 4.3335H4.0625C4.0625 3.13641 5.03208 2.16683 6.22917 2.16683C7.42625 2.16683 8.39583 3.13641 8.39583 4.3335C8.39583 5.68766 6.77083 5.82308 6.77083 7.04183Z",
    fill: "#DADADA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.890e44c2.svg";
export { ForwardRef as ReactComponent };